/**
 * State used in rendering Avatar
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
